<template>
  <div class="gs-vtabs video-vertical-tabs" :class="wrapperClass">
    <button
      type="button"
      v-for="tab in tabs"
      :key="tab.value"
      :ref="tab.value"
      :class="[
        'gs-vtabs__item',
        { 'is-active': tab.value === currentTab },
        tab.value === currentTab && tabActiveClass ? tabActiveClass : '',
        tabClass,
      ]"
      :disabled="tab.disabled || false"
      @click="handleClick(tab.value)"
      v-html="tab.title"
    />
  </div>
</template>
<script>
export default {
  name: 'VerticalTabs',
  props: {
    currentTab: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    wrapperClass: {
      type: String,
      required: false,
    },
    tabClass: {
      type: String,
      required: false,
    },
    tabActiveClass: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleClick(value) {
      this.$emit('onClick', value);
    },
  },
};
</script>
<style>
.video-vertical-tabs {
  max-width: 300px;
}

.gs-vtabs {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.gs-vtabs__item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  padding: 8px 12px;
  color: var(--gs-muted-foreground, #667085);
  font-size: 15px;
  font-weight: 500;
  line-height: 1.25;
  text-align: left;
  background: transparent;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: var(--gs-radius-sm, 6px);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.gs-vtabs__item:hover {
  color: var(--gs-foreground, #182230);
  background: var(--gs-muted, #eef2f6);
}

.gs-vtabs__item.is-active {
  color: var(--gs-foreground, #182230);
  font-weight: 700;
  background: var(--gs-primary-soft, #fff0f7);
  border-left-color: var(--gs-primary, #f22987);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.gs-vtabs__item:focus {
  outline: none;
}

.gs-vtabs__item:focus-visible {
  box-shadow: 0 0 0 3px var(--gs-ring, rgba(37, 99, 235, 0.28));
}
</style>